import styled from "styled-components";
import photo1 from "assets/images/adidas-01.jpg";
import photo2 from "assets/images/adidas-02.jpg";
import photoMobile1 from "assets/images/adidas-mobile-01.jpg";
import photoMobile2 from "assets/images/adidas-mobile-02.jpg";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: 100%;
  }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 96px 88px 96px 566px;

  @media screen and (max-width: 1010px) {
    padding: 180px 40px 40px 40px;
    height: auto;
  }

  @media screen and (max-width: 414px) {
    padding-top: 120px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 279px;
  font-size: 15px;
  line-height: 22px;
  color: black;

  p {
    margin-bottom: 24px;

    a {
      text-decoration: underline;
      color: black;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1010px) {
    max-width: 100%;
  }
`;

export const PhotosWrapper = styled.div`
  display: flex;
  height: 100%;
  column-gap: 10px;
  position: relative;

  &.mobile {
    display: none;
  }

  @media screen and (max-width: 1010px) {
    display: none;

    &.mobile {
      display: flex;
      flex-direction: column;
      column-gap: unset;
      row-gap: 10px;
    }
  }
`;

export const Background1 = styled.div`
  width: 100vw;
  height: 100%;
  background: url(${photo1}) no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
`;

export const Background2 = styled.div`
  width: 100vw;
  height: 100%;
  background: url(${photo2}) no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
`;

export const Photo1 = styled.img.attrs({ src: photoMobile1 })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Photo2 = styled.img.attrs({ src: photoMobile2 })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Credit = styled.span`
  font-size: 15px;
  line-height: 22px;
  display: block;
  position: absolute;
  top: 32px;
  left: 32px;
  color: black;

  @media screen and (max-width: 1010px) {
    top: 24px;
    left: 40px;
    font-size: 12px;
  }
`;
